export default __webpack_public_path__ + "locales/ar-SA/PaymentsEnterprise.json?hash=6b2492bb8351f32ae7f8a3180463f0ae";